import { auth } from "../firebase";

const calculatePortfolio = async () => {
  const user = auth.currentUser;
  if (!user) return;

  try {
    const token = await user.getIdToken();

    const functionUrl = "https://calculateportfolio-5dhfwyjvzq-uc.a.run.app";

    const res = await fetch(functionUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      }
    });

    if (!res.ok) {
      throw new Error(`Cloud Function returned status: ${res.status}`);
    }


  } catch (error) {
    console.error("Manual portfolio update failed:", error);
  }
};

export default calculatePortfolio;